import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { TrendingUp, LayoutDashboard, DollarSign, Car, Users as UsersIcon } from "lucide-react";
import { api } from "../../lib/api";
import { Skeleton } from "./_shared";

/* ---------------- Dashboard ---------------- */
export default function DashboardTab() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <Skeleton />;

  const cards = [
    { label: "Revenue (paid)", value: `$${stats.revenue_paid_usd.toLocaleString()}`, icon: TrendingUp, color: "text-burgundy" },
    { label: "Total bookings", value: stats.total_bookings, icon: DollarSign, color: "text-platinum" },
    { label: "Confirmed", value: stats.confirmed, icon: LayoutDashboard, color: "text-platinum" },
    { label: "Pending payment", value: stats.pending, icon: LayoutDashboard, color: "text-yellow-400" },
    { label: "Rides vs Rentals", value: `${stats.rides} · ${stats.rentals}`, icon: Car, color: "text-platinum" },
    { label: "Users", value: stats.users, icon: UsersIcon, color: "text-platinum" },
    { label: "Fleet", value: stats.vehicles, icon: Car, color: "text-platinum" },
    { label: "Drivers", value: stats.drivers, icon: UsersIcon, color: "text-platinum" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((c) => (
        <div key={c.label} data-testid={`bo-stat-${c.label.toLowerCase().replace(/\s|\W/g,'-')}`}
          className="glass rounded-2xl p-5">
          <c.icon size={16} className={`${c.color} mb-2`} />
          <div className="label-caps text-white/50 mb-1">{c.label}</div>
          <div className="font-serif text-2xl">{c.value}</div>
        </div>
      ))}
    </div>
  );
}

